module.exports = __webpack_public_path__ + "img/D-pic-01.884a8f8f.png";